import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';
import Cookies from 'universal-cookie';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/";
const idAdministrativo = cookie.get("idAdministrativo");
class SidebarColecturia extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);

                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft" id="sidenavAccordion">
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal Colecturía</p>
                        </div>

                        <Link to="/colecturia" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal A
                        </Link>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAdministrativo"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-hospital-user me-2"></i> Colecturía
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapseAdministrativo">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/colecturia/MatriculaCarrPeriodoColecturia" className="nav-sub-link">Costos de Matrícula</Link>
                                    <Link to="/colecturia/ColegiaturaCarrPeriodoColecturia" className="nav-sub-link">Costos de Colegiatura</Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseInscripcion"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-clipboard me-2"></i> Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapseInscripcion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/colecturia/ListarEstInscriAproColecturia" className="nav-sub-link">Pagos de Matrícula</Link>
                                    <Link to="/colecturia/ListarEstudiantesMatriculaCancelada" className="nav-sub-link">Estudiantes con Pagos Cancelados</Link>
                                    <Link to="/colecturia/ListarEstuPagoMatriFecha" className="nav-sub-link">Pagos de Matrículas por Fechas</Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculas"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i> Colegiaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapseMatriculas">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/colecturia/ColegiaturasEstCarreraCiclo" className="nav-sub-link">Reporte de Colegiaturas (Carrera y Ciclo)</Link>
                                    <Link to="/colecturia/ColegiaturasEstxFechas" className="nav-sub-link">Reporte de Estudiante por Fechas</Link>
                                    <Link to="/colecturia/ColegiaturasGeneralxFechas" className="nav-sub-link">Reporte General de abonos por fechas</Link>
                                    <Link to="/colecturia/ColegiaturasEstColegiaturaPagada" className="nav-sub-link">Reporte de Colegiaturas Pagadas</Link>
                                    <Link to="/colecturia/ColegiaturasEstColegiaturaUnPago" className="nav-sub-link">Reporte de Pagos del ciclo completo</Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePlataforma"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i> Plataforma
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapsePlataforma">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/colecturia/EstadoEstCarreraCicloColect" className="nav-sub-link">Estado de Estudiantes</Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfil"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i> Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapsePerfil">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/colecturia/VerPerfilColecturia" className="nav-sub-link">Ver Perfil</Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario: <br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}
export default withRouter(SidebarColecturia);
